import { DateValue } from '@internationalized/date';
import { toISODateString } from '@rematter/common/dateTime';
import { ReceivedLineItemInput } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const brokeredLoadMarkAsReceivedAtom = createMutationAtomFactory(
  'brokerage.brokeredLoadMarkAsReceived',
  (params: {
    loadId: string;
    receivedDate: DateValue;
    receivedLineItems: ReceivedLineItemInput[];
  }) => ({
    tradeLoadReceive: {
      __args: {
        id: params.loadId,
        receivedDate: toISODateString(params.receivedDate),
        receivedLineItems: params.receivedLineItems,
        reviewed: true,
      },
      id: true,
      status: true,
      loadReceivedDate: true,
    },
  }),
  {
    skipQueue: true,
  },
);
